// model/Post.js
import { Model, Relation } from "@nozbe/watermelondb";
import { field, relation } from "@nozbe/watermelondb/decorators";
import Terminal from "./Terminal";

export default class InvoiceSequence extends Model {
  static table = "invoice_sequence";
  @relation("terminals", "terminal_id") terminal: Relation<Terminal>;
  @field("sequence") sequence: number;
}
